import styled from '@emotion/styled';

export const StyledSticky = styled.div({
    position: 'relative',
});

export const StyledStickyContent = styled.div(({ theme }) => ({
    position: 'sticky',
    right: 0,
    left: 0,
    transitionProperty: 'top, bottom',
    transitionDuration: theme.animations.getDuration('fast02'),
    transitionTimingFunction: theme.animations.getEasing('standard', 'productive'),
}));
